/**
 * İşe Alım Süresi Engine — 2026
 * Time-to-Hire ve Time-to-Fill metrikleri
 */

export const YILI = 2026;

// ============================================================================
// SEKTÖR ORTALAMALARI (Türkiye 2026)
// ============================================================================

export interface SektorBenchmark {
  sektor: string;
  ortalamaGun: number;
  minGun: number;
  maxGun: number;
}

export const SEKTOR_ORTALAMALARI: SektorBenchmark[] = [
  { sektor: "Teknoloji", ortalamaGun: 42, minGun: 35, maxGun: 50 },
  { sektor: "Finans", ortalamaGun: 38, minGun: 30, maxGun: 45 },
  { sektor: "Perakende", ortalamaGun: 20, minGun: 15, maxGun: 25 },
  { sektor: "Üretim", ortalamaGun: 28, minGun: 20, maxGun: 35 },
  { sektor: "Sağlık", ortalamaGun: 35, minGun: 25, maxGun: 45 },
  { sektor: "Eğitim", ortalamaGun: 30, minGun: 20, maxGun: 40 },
  { sektor: "Genel Ortalama", ortalamaGun: 36, minGun: 30, maxGun: 45 },
];

// ============================================================================
// TİPLER
// ============================================================================

export type Degerlendirme =
  | "Mükemmel"
  | "İyi"
  | "Ortalama"
  | "İyileştirme Gerekli";

export interface IseAlimSonuc {
  gun: number;
  hafta: number;
  degerlendirme: Degerlendirme;
  renk: string;
  sektorOrtalamaGun: number;
  farkGun: number;
  farkYuzde: number;
  oneriler: string[];
}

// ============================================================================
// HESAPLAMA
// ============================================================================

export function hesaplaIseAlimSuresi(params: {
  ilanTarihi: string;
  iseBaslamaTarihi: string;
  sektor?: string;
}): IseAlimSonuc {
  const { ilanTarihi, iseBaslamaTarihi, sektor } = params;

  const start = new Date(ilanTarihi);
  const end = new Date(iseBaslamaTarihi);
  const diffMs = end.getTime() - start.getTime();
  const gun = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  const hafta = Math.round(gun / 7);

  // Sektör benchmark
  const benchmark =
    SEKTOR_ORTALAMALARI.find((s) => s.sektor === sektor) ||
    SEKTOR_ORTALAMALARI[SEKTOR_ORTALAMALARI.length - 1];

  const sektorOrtalamaGun = benchmark.ortalamaGun;
  const farkGun = gun - sektorOrtalamaGun;
  const farkYuzde =
    sektorOrtalamaGun > 0
      ? ((gun - sektorOrtalamaGun) / sektorOrtalamaGun) * 100
      : 0;

  // Değerlendirme
  let degerlendirme: Degerlendirme;
  let renk: string;
  if (gun <= 21) {
    degerlendirme = "Mükemmel";
    renk = "emerald";
  } else if (gun <= 30) {
    degerlendirme = "İyi";
    renk = "blue";
  } else if (gun <= 45) {
    degerlendirme = "Ortalama";
    renk = "amber";
  } else {
    degerlendirme = "İyileştirme Gerekli";
    renk = "red";
  }

  // Öneriler
  const oneriler: string[] = [];
  if (gun <= 21) {
    oneriler.push(
      "Süreciniz sektör ortalamasının çok altında — tebrikler!",
      "Mevcut sürecinizi standartlaştırarak tekrarlanabilir hale getirin."
    );
  } else if (gun <= 30) {
    oneriler.push(
      "Süreciniz iyi, küçük iyileştirmelerle mükemmel seviyeye çıkabilir.",
      "AI destekli CV ön eleme ile süreyi 5-10 gün kısaltabilirsiniz."
    );
  } else if (gun <= 45) {
    oneriler.push(
      "AI CV analizi ile ön eleme süresini %70 kısaltın.",
      "Standart mülakat şablonları ve scorecard kullanın.",
      "Karar vericilerin takvimlerini önceden ayırtın."
    );
  } else {
    oneriler.push(
      "İlan metinlerini optimize edin — net iş tanımı başvuru kalitesini artırır.",
      "Başvuru formunu sadeleştirin — uzun formlar aday kaybına neden olur.",
      "AI destekli CV analizi ile ön eleme süresini %70 kısaltın.",
      "Yedek aday havuzu oluşturun — hazır adaylar süreyi kısaltır.",
      "Otomatik bildirim ve takip sistemi kurun."
    );
  }

  return {
    gun,
    hafta,
    degerlendirme,
    renk,
    sektorOrtalamaGun,
    farkGun,
    farkYuzde,
    oneriler,
  };
}
